module.exports = __webpack_public_path__ + "img/1568095663.3bf7080c.jpg";